import React from 'react';
import { Badge } from './ui/badge';

const StatusBadge = ({ status, onClick, className = '' }) => {
  const statusConfig = {
    // Quote statuses
    draft: { label: 'Draft', color: 'bg-gray-100 text-gray-700 hover:bg-gray-200', icon: '📝' },
    sent: { label: 'Sent', color: 'bg-blue-100 text-blue-700 hover:bg-blue-200', icon: '✉️' },
    accepted: { label: 'Accepted', color: 'bg-green-100 text-green-700 hover:bg-green-200', icon: '✅' },
    declined: { label: 'Declined', color: 'bg-red-100 text-red-700 hover:bg-red-200', icon: '❌' },
    archived: { label: 'Archived', color: 'bg-gray-100 text-gray-600 hover:bg-gray-200', icon: '🗄️' },
    pending: { label: 'Pending', color: 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200', icon: '⏳' },
    
    // Order statuses
    active: { label: 'Active', color: 'bg-green-100 text-green-700 hover:bg-green-200', icon: '✅' },
    on_hold: { label: 'On Hold', color: 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200', icon: '⏸️' },
    cancelled: { label: 'Cancelled', color: 'bg-red-100 text-red-700 hover:bg-red-200', icon: '❌' },
    
    // Job statuses
    unscheduled: { label: 'Unscheduled', color: 'bg-gray-100 text-gray-700 hover:bg-gray-200', icon: '📋' },
    scheduled: { label: 'Scheduled', color: 'bg-blue-100 text-blue-700 hover:bg-blue-200', icon: '📅' },
    in_progress: { label: 'In Progress', color: 'bg-purple-100 text-purple-700 hover:bg-purple-200', icon: '🔧' },
    completed: { label: 'Completed', color: 'bg-green-100 text-green-700 hover:bg-green-200', icon: '✅' },
    invoiced: { label: 'Invoiced', color: 'bg-amber-100 text-amber-700 hover:bg-amber-200', icon: '💰' },
    paid: { label: 'Paid', color: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200', icon: '💳' },
    
    // Legacy fallback
    converted: { label: 'Converted', color: 'bg-purple-100 text-purple-700 hover:bg-purple-200', icon: '🔄' }
  };

  const config = statusConfig[status] || statusConfig.pending;

  return (
    <Badge 
      className={`
        ${config.color} 
        ${onClick ? 'cursor-pointer transition-all' : ''} 
        ${className}
      `}
      onClick={onClick}
      title={onClick ? 'Click to change status' : ''}
    >
      <span className="mr-1">{config.icon}</span>
      {config.label}
    </Badge>
  );
};

export default StatusBadge;
